import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-private-layout',
  template: `<app-sidenav>
    <app-sidenav-header sidenavHeader></app-sidenav-header>
    <app-nav-list sidenavList></app-nav-list>
    <router-outlet mainContent></router-outlet>
  </app-sidenav>`,
})
export class PrivateLayoutComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
